import { render, staticRenderFns } from "./OperateRule.vue?vue&type=template&id=2445c39d&scoped=true&"
import script from "./OperateRule.vue?vue&type=script&lang=js&"
export * from "./OperateRule.vue?vue&type=script&lang=js&"
import style0 from "./OperateRule.vue?vue&type=style&index=0&id=2445c39d&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2445c39d",
  null
  
)

export default component.exports